// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"2":"d001fb8a","490":"26a0325e"}[chunkId] + ".js";
};